import { SessionRescheduleModal } from '../../../../components/common/Modal/SesssionRescheduleModal';
import { SessionCancelModal } from '../../../../components/common/Modal/SessionCancelModal';
import { showSuccessToast, showErrorToast } from '../../../../components/PluginsMenu/Toastr/Toastr';
import user from '../../../../../images/no_user_placeholder.png'
import { Button, Card, Row, Col, Spinner, Alert } from 'react-bootstrap';
import phone from '../../../../../images/svg/phone.svg';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { useParams, useLocation, Link, useNavigate } from 'react-router-dom';
import { 
  useGetSessionDetailsQuery, 
  useCancelSessionMutation, 
  useRescheduleSessionMutation, 
  useLazyGetTutorAbsentQuery
} from '../../../../../store/services/student/SessionService';
import { formatTimeTo12Hour } from '../../../../../utils/utils';
import { useReviewTutorMutation } from '../../../../../store/services/AuthService';
import { useSelector } from 'react-redux';
import { useAdminCancelSessionMutation } from '../../../../../store/services/admin/SlotPriceService';

export const StudentSessionDetails = () => {
    const { sessionId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const { role } = useSelector((state) => state.auth);
    const isHistoryView = location.state?.fromHistory || false;
    const [modalType, setModalType] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    
    // Fetch session details
    const { data: sessionData, isLoading, error, refetch } = useGetSessionDetailsQuery({
        slotSessionId: sessionId
    });
    const [triggerMarkAbsent, { isFetching: isMarkingAbsent }] = useLazyGetTutorAbsentQuery();
    const [reviewTutor] = useReviewTutorMutation();

    // API mutations
    const [cancelSession] = useCancelSessionMutation();
    const [adminCancelSession] = useAdminCancelSessionMutation();
    const [rescheduleSession] = useRescheduleSessionMutation();

    const sessionDetails = sessionData?.data;
    
    // Time-related state
    const [sessionDateTime, setSessionDateTime] = useState(null);
    const [sessionEndDateTime, setSessionEndDateTime] = useState(null);
    
    const [newSessionDate, setNewSessionDate] = useState('');
    const [newSessionStartTime, setNewSessionStartTime] = useState('');
    const [newSessionEndTime, setNewSessionEndTime] = useState('');

    //review/rating related states
    const [rating, setRating] = useState(0);
    const [hoverRating, setHoverRating] = useState(0);
    const [comment, setComment] = useState('');
    const [isReviewing, setIsReviewing] = useState(false);
    
    const [errors, setErrors] = useState({
        date: '',
        startTime: '',
        endTime: ''
    });

    // Initialize session times when data is loaded
    useEffect(() => {
        if (sessionDetails?.scheduledTime) {
            const dateTime = dayjs(sessionDetails.scheduledTime);
            setSessionDateTime(dateTime);
            setSessionEndDateTime(dateTime.add(sessionDetails.sessionDuration || 30, 'minute'));
        }
    }, [sessionDetails]);

    // Reset form errors when modal closes
    useEffect(() => {
        if (!showModal) {
            setErrors({
                date: '',
                startTime: '',
                endTime: ''
            });
            setIsProcessing(false);
        }
    }, [showModal]);


    const handleReviewTutor = async () => {
        if (!rating) {
            showErrorToast("Please select a rating before submitting.");
            return;
        }
        setIsReviewing(true);
        try {
            const response = await reviewTutor({tutorId: sessionDetails.tutorId, count: rating,
                comment: comment.trim() || ""}).unwrap();
            if (response.succeeded) {
                showSuccessToast(response.data || "Review submitted successfully!");
                setRating(0);
                setComment("");
            } else {
                throw new Error(response.errors?.join(', ') || "Failed to submit review");
            }
        } catch (error) {
            console.log(error);
            showErrorToast(error.data?.errors?.join(', ') || "Failed to submit review.");
        } finally {
            setIsReviewing(false);
        }
    };

    const handleReschedule = () => {
        // if (sessionDateTime) {
        //     setNewSessionDate(sessionDateTime.format('YYYY-MM-DD'));
        //     setNewSessionStartTime(sessionDateTime.format('HH:mm'));
        //     setNewSessionEndTime(sessionEndDateTime.format('HH:mm'));
        // }
        // setModalType('reschedule');
        // setShowModal(true);

        // Navigate to reschedule flow with session details

        console.log("Navigating to reschedule with session details:", sessionDetails);
        navigate(`/reschedule-session/${sessionId}/${sessionDetails.tutorId}`, {
            state: {
                tutorId: sessionDetails.tutorId,
                currentSessionDate: sessionDateTime?.format('YYYY-MM-DD'),
                currentSessionDuration: sessionDetails.sessionDuration,
                sessionDurationId: sessionDetails.sessionDurationId, // You'll need to add this to your API response
                subject: sessionDetails.subject,
                subjectId: sessionDetails.subjectId,
                fromSessionDetails: true
            },
            search: `?tutorId=${sessionDetails.tutorId}`
        });
    };

    const handleCancel = () => {
        setModalType('cancel');
        setShowModal(true);
    };

    // Updated handleRescheduleSuccess with API call
    const handleRescheduleSuccess = async (startDateTime, duration) => {
        setIsProcessing(true);
        
        try {
            const reschedulePayload = {
                sessionBookingId: sessionId,
                newDate: startDateTime.format('YYYY-MM-DD'),
                startTime: startDateTime.format('HH:mm'),
                endTime: startDateTime.add(duration, 'minute').format('HH:mm')
            };

            console.log('Reschedule payload:', reschedulePayload);

            const response = await rescheduleSession(reschedulePayload).unwrap();

            if (response.succeeded) {
                showSuccessToast(response.data || "Session rescheduled successfully!");
                setShowModal(false);
                // Refetch session details to get updated information
                refetch();
            } else {
                throw new Error(response.errors?.join(', ') || 'Reschedule failed');
            }
        } catch (error) {
            console.error("Error rescheduling session:", error);
            showErrorToast(error.data?.errors?.join(', ') || "Failed to reschedule session. Please try again.");
        } finally {
            setIsProcessing(false);
        }
    };

    // Updated handleCancelSuccess with API call
    const handleCancelSuccess = async () => {
        setIsProcessing(true);
        
        try {
            const response = role === "Admin" ? await adminCancelSession({ sessionBookingId: sessionId }).unwrap() : await cancelSession({ SessionBookingId: sessionId }).unwrap();

            if (response.succeeded) {
                showSuccessToast(response.data || "Session cancelled successfully!");
                setShowModal(false);
                // Redirect to sessions list or refetch details
                refetch();
                // Optionally navigate back to sessions list
                // navigate('/sessions');
            } else {
                throw new Error(response.errors?.join(', ') || 'Cancellation failed');
            }
        } catch (error) {
            console.error("Error cancelling session:", error);
            showErrorToast(error.data?.errors?.join(', ') || "Failed to cancel session. Please try again.");
        } finally {
            setIsProcessing(false);
        }
    };

    const handleCloseModal = () => {
        if (!isProcessing) {
            setShowModal(false);
        }
    };

    if (isLoading) {
        return (
            <div className="container-fluid py-5">
                <div className="text-center py-5">
                    <Spinner animation="border" role="status" className="me-2" />
                    Loading session details...
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container-fluid py-5">
                <Alert variant="danger">
                    Error loading session details. Please try again.
                </Alert>
            </div>
        );
    }

    if (!sessionDetails) {
        return (
            <div className="container-fluid py-5">
                <Alert variant="warning">
                    Session not found.
                </Alert>
            </div>
        );
    }

    const formattedSessionDate = sessionDateTime ? sessionDateTime.format('MMM D, YYYY - h:mm A') : 'Loading...';
    const sessionDuration = sessionDetails.sessionDuration ? `${sessionDetails.sessionDuration} minutes` : 'Loading...';

    const handleMarkAsAbsent = async () => {
        try {
            const response = await triggerMarkAbsent({ SlotSessionId: sessionId }).unwrap();
            if (response?.succeeded) {
                showSuccessToast(response.data || "Marked as absent successfully!");
                refetch(); 
            } else {
                throw new Error(response?.errors?.join(", ") || "Failed to mark as absent");
            }
        } catch (error) {
            console.error("Error marking as absent:", error);
            showErrorToast(error?.data?.errors?.join(", ") || "Failed to mark as absent. Please try again.");
        } 
    };

    return (
        <>
            <div className="container-fluid py-5 pb-0">
                <Card className="shadow-lg rounded-lg">
                    <Card.Body>
                        {/* Session Header */}
                        <Row className="mb-4">
                            <Col className="d-flex align-items-center">
                                <div>
                                    <h4 className="text-dark font-weight-bold mb-2">
                                        Session with Tutor {sessionDetails.tutorName}
                                    </h4>
                                    <span className={`badge py-2 px-4 fs-5 ${
                                        sessionDetails.sessionStatus === 'Scheduled' ? 'bg-primary' :
                                        sessionDetails.sessionStatus === 'Completed' ? 'bg-success' :
                                        sessionDetails.sessionStatus === 'Cancelled' ? 'bg-danger' : 'bg-warning'
                                    } text-white`}>
                                        {sessionDetails.sessionStatus}
                                    </span>
                                </div>
                            </Col>
                        </Row>

                        {/* Session Details */}
                        <Row className="g-4">
                            {/* Student Info */}
                            <Col xs={12} md={3}>
                                <h6 className="text-muted mb-2">Student</h6>
                                <div className="d-flex align-items-center">
                                    <img 
                                        src={sessionDetails?.studentImage ? `${process.env.REACT_APP_IMAGE_PATH}${sessionDetails.studentImage}` : user} 
                                        alt="Student" 
                                        className="avatar avatar-xl me-2" 
                                    />
                                    <span className="text-primary">{sessionDetails?.studentName}</span>
                                </div>
                            </Col>

                            {/* Tutor Info */}
                            <Col xs={12} md={3}>
                                <h6 className="text-muted mb-2">Tutor</h6>
                                <div className="d-flex align-items-center">
                                    <img 
                                        src={sessionDetails?.tutorImage ? `${process.env.REACT_APP_IMAGE_PATH}${sessionDetails.tutorImage}` : user} 
                                        className="avatar avatar-xl me-2"
                                    />
                                    <span className="text-primary">{sessionDetails?.tutorName}</span>
                                </div>
                            </Col>

                            {/* Scheduled Time */}
                            <Col xs={12} md={3}>
                                <h6 className="text-muted mb-2">Scheduled Time</h6>
                                <div>
                                    <i className="fa fa-calendar text-success me-2"></i>
                                    {/* {formattedSessionDate} */}
                                    {formatTimeTo12Hour(sessionDetails.scheduledTime)}
                                </div>
                            </Col>

                            {/* Session Duration */}
                            <Col xs={12} md={3}>
                                <h6 className="text-muted mb-2">Session Duration</h6>
                                <div className="d-flex align-items-center">
                                    <img src={phone} alt="Duration" className="me-2" />
                                    <span>{sessionDuration}</span>
                                </div>
                            </Col>
                        </Row>

                        {/* Session Notes and Agenda */}
                        <Row className="g-4 mt-4">
                            <Col xs={12} md={3}>
                                <h6 className="text-muted mb-2">Student Notes</h6>
                                <p className="text-muted">
                                    {sessionDetails.studentSessionNotes || 'No session notes available.'}
                                </p>
                            </Col>

                            <Col xs={12} md={3}>
                                <h6 className="text-muted mb-2">Student Proficiency</h6>
                                <p className="badge bg-primary">
                                    {sessionDetails.proficiency || 'No student proficiency available.'}
                                </p>
                            </Col>

                            <Col xs={12} md={6}>
                                <h6 className="text-muted mb-2">{`${(sessionDetails.sessionStatus === 'Scheduled' || sessionDetails.sessionStatus === 'Rescheduled' || sessionDetails.sessionStatus === 'Cancelled' ) ?  "Meeting Link" : "Recording Link"}`}</h6>
                                {sessionDetails.recordingLink ? 
                                <Link to={sessionDetails.recordingLink} target="_blank">
                                    {sessionDetails.recordingLink}
                                </Link> :
                                'No link available'
                                }
                            </Col>

                            {/* <Col xs={12} md={6}>
                                <h6 className="text-muted mb-2">Agenda</h6>
                                <ul className="text-muted">
                                    {sessionDetails.agenda ? (
                                        sessionDetails.agenda.split('\n').map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))
                                    ) : (
                                        <li>No agenda items specified</li>
                                    )}
                                </ul>
                            </Col> */}
                        </Row>

                        {/* Action Buttons - Only show for scheduled sessions */}
                        {(sessionDetails.sessionStatus === 'Scheduled' || sessionDetails.sessionStatus === 'Rescheduled') && (
                            <Row className="mt-5">
                                <Col>
                                    <div className="d-flex flex-column flex-md-row justify-content-start">
                                        <Button 
                                            variant="warning" 
                                            className="btn-md me-md-3 mb-3 mb-md-0" 
                                            onClick={handleReschedule}
                                            disabled={isProcessing}
                                        >
                                            Reschedule Session
                                        </Button>
                                        <Button 
                                            variant="danger" 
                                            className="btn-md" 
                                            onClick={handleCancel}
                                            disabled={isProcessing}
                                        >
                                            Cancel Session
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        )}

                        {isHistoryView && sessionDetails.sessionStatus === 'Completed' && (
                        <div className="d-flex flex-column flex-md-row justify-content-end">
                            <Button variant="secondary" className="btn-md mb-3 mb-md-0 mt-2" 
                                disabled={isMarkingAbsent}  onClick={handleMarkAsAbsent}>
                                    {isMarkingAbsent ? "Marking..." : "Mark Tutor as Absent"}
                            </Button>
                        </div>
                        )} 

                        {sessionDetails.sessionStatus === "Completed" && role !== "Admin" && (
                            <div className="mt-5 p-4 border rounded bg-light">
                                <h5 className="mb-3 text-dark">Leave a Review for {sessionDetails.tutorName}</h5>
                                <div className="mb-3 d-flex gap-2">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <span key={star} style={{cursor: "pointer", fontSize: "28px",
                                            color: (hoverRating || rating) >= star ? "#ffc107" : "#e4e5e9",
                                            transition: "color 0.2s" }} onClick={() => setRating(star)}
                                            onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} >
                                                ★
                                        </span>
                                    ))}
                                </div>

                                <textarea className="form-control mb-3" rows={3}
                                    placeholder="Write your feedback (optional)" value={comment}
                                    onChange={(e) => setComment(e.target.value)} />

                                <Button variant="success" className="btn-md" onClick={handleReviewTutor}
                                    disabled={isReviewing} >{isReviewing ? "Submitting..." : "Submit Review"}
                                </Button>
                            </div>
                        )}

                    </Card.Body>
                </Card>
            </div>

            {modalType === "reschedule" && (
                <SessionRescheduleModal
                    show={showModal}
                    handleClose={handleCloseModal}
                    onSuccess={handleRescheduleSuccess}
                    initialDate={sessionDateTime?.format("YYYY-MM-DD")}
                    initialStartTime={sessionDateTime?.format("HH:mm")}
                    initialEndTime={sessionEndDateTime?.format("HH:mm")}
                    isProcessing={isProcessing}
                />
            )}

            {modalType === "cancel" && (
                <SessionCancelModal
                    show={showModal}
                    handleClose={handleCloseModal}
                    onSuccess={handleCancelSuccess}
                    isProcessing={isProcessing}
                />
            )}
        </>
    );
};